export var HolidayActionKind;
(function (HolidayActionKind) {
    HolidayActionKind["AddHoliday"] = "AddHoliday";
    HolidayActionKind["RemoveHoliday"] = "RemoveHoliday";
    HolidayActionKind["InitialiseHolidays"] = "InitialiseHolidays";
    HolidayActionKind["AddHolidayBooking"] = "AddHolidayBooking";
    HolidayActionKind["RemoveHolidayBooking"] = "RemoveHolidayBooking";
    HolidayActionKind["UpdateHolidayBooking"] = "UpdateHolidayBooking";
    HolidayActionKind["InitialiseHolidayBookings"] = "InitialiseHolidayBookings";
})(HolidayActionKind || (HolidayActionKind = {}));
